// route constants for the application
export const baseURLRoute = '/evaluator'

export const BASE_ROUTE_ENDPOINTS = {
    LOGIN: baseURLRoute,
    VETEVALFORM: 'vet-eval-form',
    REGISTER: 'register',
    REGISTER_TMD: 'register-tmdsas',
    REGISTER_JAMP: 'register-jamp',
    DASHBOARD: 'dashboard',
    MYACCOUNT: 'my-account',
    FORGOTPASSWORD: 'forgot-password',
    EVALLETTERFORM: 'eval-letter-form',
    FORGOTPASSWORDTMDSAS: 'forgot-password-tmdsas',
    UPDATEPROFILE: 'update-profile',
    // Add more endpoints as needed
}

export const NAVIGATION_LINKS = {
    VETEVALFORM: `${baseURLRoute}/${BASE_ROUTE_ENDPOINTS.VETEVALFORM}`,
    EVALLETTERFORM: `${baseURLRoute}/${BASE_ROUTE_ENDPOINTS.EVALLETTERFORM}`,
    DASHBOARD: `${baseURLRoute}/${BASE_ROUTE_ENDPOINTS.DASHBOARD}`,
    UPDATEPROFILE: `${baseURLRoute}/${BASE_ROUTE_ENDPOINTS.UPDATEPROFILE}`,
    FORGOTPASSWORDTMDSAS: `${baseURLRoute}/${BASE_ROUTE_ENDPOINTS.FORGOTPASSWORDTMDSAS}`,
    REGISTER_TMD: `${baseURLRoute}/${BASE_ROUTE_ENDPOINTS.REGISTER_TMD}`,
    REGISTER_JAMP: `${baseURLRoute}/${BASE_ROUTE_ENDPOINTS.REGISTER_JAMP}`,
    // Add more navigation links as needed
}
